import {ProductsRelDocs} from "../../interfaces";
import {sendGAEvent} from "../../../../../domain/marketing/gtm-provider";
import { getHiddenDataString } from '../../../../../domain/hidden-data-provider';
import ProductSubscriptionTiers from "../../../subscription/sbs-tiers";
import {IListItem} from "../../../../list-page/interfaces/interfaces";
import {outbrainAddToCartEvent} from "../../../../../domain/marketing/outbrain-provider";
interface IProductGetAccessProps {
    product: ProductsRelDocs,
    classEx?: string
    classBtn?: string
    classTryIt?: string
    hideTryIt?:boolean
    showBadge?:boolean
    source?: string
}
/**
 * the entry point
 */
const PRDGetAccess = (props: IProductGetAccessProps) => {

    const product = props.product;
    const prodctListItem = {sbsIncludedIn:product.includedInSBS} as IListItem;
    // subscription + variants
    let getAccessText = getHiddenDataString('sbs-button-text'); //'Get Access';
    let isSbsFreeTrial : boolean = (getHiddenDataString('is-sbs-free-trial') ==='true'); //if false => Try it Free;

    return (
            <>
                {
                    <div className={'prd-get-access w-full flex flex-row items-center ' + (props.classEx && props.classEx !== '' ? props.classEx : '')}>
                        {
                            props?.showBadge && <ProductSubscriptionTiers product={ prodctListItem } isGrid={ false } classEx="flex-none mr-2" />
                        }
                        <div className={``}>
                            <a href={'/subscriptions?skus=' + product.skuid} className={"w-btn bg-yellow-400 text-gray-700 " + props?.classBtn ?? '' } data-skunumber={ product.skuNumber }
                               onClick={ evt => {
                                   sendGAEvent(
                                      'Click',
                                       (props.source && props.source === 'sticky') ? getAccessText + ' Sticky' : getAccessText, // 'Get Access'
                                   );
                                   outbrainAddToCartEvent();
                               }}
                            >{getAccessText}</a>
                        </div>
                        {!isSbsFreeTrial && !props?.hideTryIt &&
                            <div className={`ml-8`}><a href={'/subscriptions?skus=' + product.skuid} className={'underline '+ props.classTryIt}>Try it Free</a></div>
                        }

                    </div>
                }
            </>
    )
};

export default PRDGetAccess;